interface ChatMockupProps {
    firstName: string;
    lastName: string;
    avatarUrl: string | null;
}

export const ChatMockup = ({ firstName, lastName, avatarUrl }: ChatMockupProps) => {
    const initials = `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase() || 'MM';
    const fullName = `${firstName || 'Max'} ${lastName || 'Muster'}`.trim() || 'Max Muster';

    return (
        <div className="relative">
            {/* Fade overlay top */}
            <div className="absolute left-0 right-0 top-0 h-12 bg-gradient-to-b from-gray-100 to-transparent z-10 pointer-events-none" />
            {/* Fade overlay bottom */}
            <div className="absolute left-0 right-0 bottom-0 h-12 bg-gradient-to-t from-gray-100 to-transparent z-10 pointer-events-none" />

            <div className="overflow-hidden rounded-lg">
                <div className="bg-white shadow-lg min-h-[280px] -my-4">
                    {/* Abstract previous messages */}
                    <div className="flex gap-3 px-4 py-2 opacity-40">
                        <div className="w-9 h-9 rounded-md bg-gray-200 flex-shrink-0" />
                        <div className="flex-1">
                            <div className="flex items-baseline gap-2 mb-1">
                                <div className="h-3 w-24 bg-gray-200 rounded" />
                                <div className="h-2 w-16 bg-gray-100 rounded" />
                            </div>
                            <div className="h-3 w-48 bg-gray-100 rounded mb-1" />
                            <div className="h-3 w-32 bg-gray-100 rounded" />
                        </div>
                    </div>

                    <div className="flex gap-3 px-4 py-2 opacity-50">
                        <div className="w-9 h-9 rounded-md bg-gray-200 flex-shrink-0" />
                        <div className="flex-1">
                            <div className="flex items-baseline gap-2 mb-1">
                                <div className="h-3 w-20 bg-gray-200 rounded" />
                                <div className="h-2 w-14 bg-gray-100 rounded" />
                            </div>
                            <div className="h-3 w-40 bg-gray-100 rounded" />
                        </div>
                    </div>

                    {/* Highlighted user message */}
                    <div className="flex gap-3 px-4 py-2 bg-blue-50/50 border-l-2 border-blue-400">
                        <div className="w-9 h-9 rounded-md bg-gray-100 flex items-center justify-center text-sm font-semibold text-gray-900 overflow-hidden flex-shrink-0">
                            {avatarUrl ? (
                                <img src={avatarUrl} className="w-full h-full object-cover" alt="" />
                            ) : (
                                initials
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-baseline gap-2 mb-0.5">
                                <span className="font-semibold text-gray-900 text-sm">{fullName}</span>
                                <span className="text-xs text-gray-500">Heute, 14:32</span>
                            </div>
                            <div className="text-sm text-gray-900">Ich habe die Arbeit fertiggestellt.</div>
                        </div>
                    </div>

                    {/* Abstract following messages */}
                    <div className="flex gap-3 px-4 py-2 opacity-50">
                        <div className="w-9 h-9 rounded-md bg-gray-200 flex-shrink-0" />
                        <div className="flex-1">
                            <div className="flex items-baseline gap-2 mb-1">
                                <div className="h-3 w-28 bg-gray-200 rounded" />
                                <div className="h-2 w-12 bg-gray-100 rounded" />
                            </div>
                            <div className="h-3 w-36 bg-gray-100 rounded" />
                        </div>
                    </div>

                    <div className="flex gap-3 px-4 py-2 opacity-40">
                        <div className="w-9 h-9 rounded-md bg-gray-200 flex-shrink-0" />
                        <div className="flex-1">
                            <div className="flex items-baseline gap-2 mb-1">
                                <div className="h-3 w-20 bg-gray-200 rounded" />
                                <div className="h-2 w-16 bg-gray-100 rounded" />
                            </div>
                            <div className="h-3 w-52 bg-gray-100 rounded mb-1" />
                            <div className="h-3 w-24 bg-gray-100 rounded" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};